<template>
  <div class="relative overflow-hidden bg-[#0D0D0D] min-h-screen">
    <!-- Background Overlay -->
    <img
      src="@/assets/hero-bg.jpg"
      class="absolute inset-0 z-0 object-cover w-full h-full opacity-20"
      alt="background-image"
    />

    <!-- Main Content -->
    <section class="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 text-center">
      <!-- Heading -->
      <h1
        @click="goHome"
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
        class="py-10 sm:py-16 px-4 sm:px-10 mb-6 text-4xl md:text-5xl font-bold md:font-black tracking-wide rounded-full cursor-pointer relative overflow-hidden transition-all duration-500 border border-[#30A733] shadow-[0_0_30px_#30A73350] w-full sm:max-w-[420px] text-center"
        :class="hovering ? 'bg-[#30A733] text-black' : 'bg-black text-[#30A733]'"
      >
        <span
          class="absolute inset-0 flex items-center justify-center transition-transform duration-500"
          :class="hovering ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'"
        >
          We're sorry!
        </span>
        <span
          class="absolute inset-0 flex items-center justify-center transition-transform duration-500"
          :class="hovering ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'"
        >
          Go back
        </span>
      </h1>

      <!-- Message -->
      <p class="text-white text-base sm:text-lg md:text-xl mb-4 max-w-xl">
        Access Denied. You must meet all the requirements to view the whole site.
      </p>

      <!-- Go Back Link -->
      <p
        @click="goHome"
        class="text-[#30A733] text-base font-semibold underline underline-offset-4 cursor-pointer hover:text-white transition duration-300"
      >
        Return to Home Page
      </p>
    </section>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      hovering: false,
    };
  },
  computed: {
    ...mapState(["showApology"]),
  },
  methods: {
    ...mapActions(["toggleApology"]),
    goHome() {
      this.$router.push("/");
    },
  },
  mounted() {
    if (!this.showApology) {
      this.$router.push("/");
    }
  },
};
</script>
